import { Form, Input, Row, Col, Switch, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../system/WebEditUniversalNewEx';
import fetchApi from '../../utils/api/fetchApi';
import getList from '../../utilsTsx/universal/getList';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const EditComponent = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();

    const [faPiaoSupplierData, setFaPiaoSupplierData] = useState<any>();

    useEffect(() => {
        let serviceUrl;
        if (ref.current) {
            serviceUrl = ref.current.defaultService;
            setDefaultService(serviceUrl);
            setInitData(() => ref.current.initData);
        }
        fetchApi.GET(serviceUrl,
            {
                apiId: 'generalData',
                apiVariable: 'faPiaoSupplier',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success === true) {
                    const { faPiaoSupplier } = res.data;
                    setFaPiaoSupplierData(faPiaoSupplier);
                }
            })
    }, []);

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'faPiaoSupplier',
        serviceId: 'business'
    };

    const onSelectHandle = (e: any) => {
        form.setFieldValue('supplierName', e.item.name);
    }

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '发票供应商'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            // handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id"
                                rules={[{ required: true, message: 'id!' }]}>
                                <Select
                                    disabled={data.type === 'NEW' ? false : true}
                                    showSearch
                                    placeholder="id"
                                    optionFilterProp="children"
                                    onSelect={(_key, e) => onSelectHandle(e)}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(faPiaoSupplierData, {
                                        setItemNameFun: (item: any) => {
                                            const { id, name } = item;
                                            return {
                                                id,
                                                name: `${id}【${name}】`
                                            }
                                        }
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="名称"
                                name="supplierName"
                                rules={[{ required: true, message: '名称!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="内容"
                                tooltip='JSON.stringify格式，例如：{ "abc": "1" }'
                                name="contents">
                                <Input.TextArea
                                    placeholder="内容"
                                    rows={10}>
                                </Input.TextArea>
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;